// extracted by mini-css-extract-plugin
export var container = "cardGrid-module--container--OFI9T";
export var grid = "cardGrid-module--grid--climk";
export var label = "cardGrid-module--label--H88jg";
export var card = "cardGrid-module--card--t0THV";
export var slideUp = "cardGrid-module--slideUp--Go8Wm";
export var slideUpLarge = "cardGrid-module--slideUpLarge--14EZT";